export const INPUT_AREA_HEIGHT = "INPUT_AREA_HEIGHT";
